import React, { useState } from 'react';
import CountrySelector from '../components/CountrySelector';
import PhoneInput from 'react-phone-number-input';
import ContactUsBackground from '../assets/contact_us-background.png';
import MessageSVG from '../assets/mail.svg';
import PhoneSVG from '../assets/phone-call.svg';
import '../styles/ContactUsHeader.css';
import '../styles/ContactUsMain.css';
import 'react-phone-number-input/style.css';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
    const [contactUsName, setContactUsName] = useState('');
    const [contactUsEmail, setContactUsEmail] = useState('');
    const [contactUsCity, setContactUsCity] = useState('');
    const [contactUsCountry, setContactUsCountry] = useState('');
    const [contactUsZipCode, setContactUsZipCode] = useState('');
    const [contactUsPhone, setContactUsPhone] = useState('');
    const [contactUsMessage, setContactUsMessage] = useState('');
    const addressData = [
        { country: 'United States', location: '4034 W Lawrence Ave, STE 3, Chicagi, IL 60630, USA' },
        { country: 'India', location: 'A 204, Nirman Complex, Opp Hocco Restaurant, Navrangpura, Ahmedabad-380009' }
    ];

    const contactInfo = [
        { country: 'United States', email: 'amderoninc@gmail.com', phone: '+1 909 490 9086' },
        { country: 'India', email: 'amderonamd@gmail.com', phone: '+91 999 801 0077' }
    ];

    const handleCountryChange = (selectedCountry) => {
        setContactUsCountry(selectedCountry);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formDetails = {
            name: contactUsName,
            email: contactUsEmail,
            country: contactUsCountry,
            city: contactUsCity,
            zipCode: contactUsZipCode,
            number: contactUsPhone,
            description: contactUsMessage
        };
        emailjs.send('service_bweo396', 'template_g2n6cc9', formDetails, '3YyDVJ1mlye_xPa7F')
        setContactUsName('')
        setContactUsEmail('')
        setContactUsCity('')
        setContactUsCountry('')
        setContactUsZipCode('')
        setContactUsPhone('')
        setContactUsMessage('')
    };


    return (
        <>
            <header>
                <div className="contact_us-header-wrapper">
                    <img src={ContactUsBackground} alt="" className="contact_us-header-image" />
                    <div className="contact_us-image-gradient" />
                    <div className="row">
                        <div className="contact_us-header-content">
                            <h1 className="contact_us-header-title">Contact Us</h1>
                            <p className="contact_us-header-subtitle">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="row">
                    <div className="contact_us-main-wrapper">
                        <div className="contact_us-information">
                            <div className="contact_us-information-address-wrapper">
                                <h1 className="contact_us-information-addresses-title">Location</h1>
                                <ul className="contact_us-addresses">
                                    {
                                        addressData.map((address, index) => {
                                            return (
                                                <li className="contact_us-address" key={index}>
                                                    <h3 className="contact_us-address-country contact_us-country">{address.country}</h3>
                                                    <p className="contact_us-address-location">{address.location}</p>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="contact_us-information-contacts-wrapper">
                                <h1 className="contact_us-information-contact-title">Contact Info</h1>
                                <ul className="contact_us-contact-list">
                                    {
                                        contactInfo.map((info, index) => {
                                            return (
                                                <div className="contact_us-contact" key={index}>
                                                    <h3 className="contact_us-contact-country-title contact_us-country">{info.country}</h3>
                                                    <div className="contact_us-contact-mail-wrapper">
                                                        <img src={MessageSVG} alt="" className="contact_us-contact-mail-svg" />
                                                        <p className="contact_us-contact-email">{info.email}</p>
                                                    </div>
                                                    <div className="contact_us-contact-phone-wrapper">
                                                        <img src={PhoneSVG} alt="" className="contact_us-contact-phone-svg" />
                                                        <p className="contact_us-contact-phone">{info.phone}</p>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="contact_us-form-wrapper">
                            <h1 className="contact_us-form-title">Consultation Request</h1>
                            <p className="contact_us-form-para">Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin,
                                lorem quis bibendum nisi elit consequat ipsum, nec sagittis sebh id sed sit.
                            </p>
                            <form className="contact_us-form" onSubmit={handleSubmit}>
                                <input required type="text" className="contact_us-form-name" placeholder="Name" value={contactUsName} onChange={(event) => setContactUsName(event.target.value)} />
                                <input required type="email" className="contact_us-form-email" placeholder="Email" value={contactUsEmail} onChange={(event) => setContactUsEmail(event.target.value)} />
                                <div className="form_country-city-wrapper">
                                    <CountrySelector
                                        value={contactUsCountry}
                                        onChange={handleCountryChange}
                                    />
                                    <input required type="text" className="contact_us-form-city" placeholder="City" value={contactUsCity} onChange={(event) => setContactUsCity(event.target.value)} />
                                </div>
                                <input required type="text" className="contact_us-form-zip" placeholder="Zip Code" value={contactUsZipCode} onChange={(event) => setContactUsZipCode(event.target.value)} />
                                <PhoneInput
                                    className='contact_us-form-phone'
                                    placeholder="Phone Number"
                                    defaultCountry='IN'
                                    value={contactUsPhone}
                                    onChange={setContactUsPhone}
                                    required
                                />
                                <textarea required className="contact_us-form-case" placeholder="Case Description..." value={contactUsMessage} onChange={(event) => setContactUsMessage(event.target.value)} />
                                <button type="submit" className="contact_us-form-submit">Send Request</button>
                            </form>
                        </div>
                    </div>
                </div>
            </main >
        </>
    );
}

export default ContactUs;